export const supported = ['de', 'fr'];

export default supported;
